import React from "react";
import "./menu.css";

const menuData = [
  {
    day: "Friday",
    meals: [
      {
        title: "Dinner",
        sections: [
          { group: "Starter", label: "Starter", value: "Soup and bread", tone: "starter" },
          { group: "Mains", label: "Main course 1", value: "Pulled pork burger with apple slaw", tone: "main" },
          { group: "Mains", label: "Main course 2", value: "Jacket potato and pasta bar with toppers", tone: "main-alt" },
          { group: "Mains", label: "Vegan", value: "Pulled BBQ jackfruit and aubergine burger", tone: "vegan" },
          { group: "Sides", label: "Sides", value: "Corn on the cob, Mucho peas and peri wedges", tone: "sides" },
          { group: "Dessert", label: "Dessert", value: "Chocolate banana bread", tone: "dessert" },
        ],
      },
    ],
  },
  {
    day: "Saturday",
    meals: [
      {
        title: "Breakfast",
        sections: [
          { label: "Porridge", value: "With honey or golden syrup", tone: "breakfast" },
          {
            label: "Cooked breakfast",
            value: "Bacon, hash browns, baked beans, scrambled eggs and grilled tomatoes",
            tone: "cooked",
          },
          {
            label: "Cold breakfast",
            value: "Selection of cereals and yoghurt with a variety of toppings",
            tone: "cold",
          },
        ],
      },
      {
        title: "Dinner",
        sections: [
          { group: "Starter", label: "Starter", value: "Soup and bread", tone: "starter" },
          {
            group: "Mains",
            label: "Main course 1",
            value: "Beef chilli with pea mole, sour cream and tomato salsa",
            tone: "main",
          },
          { group: "Mains", label: "Main course 2", value: "Jacket potato and pasta bar with toppers", tone: "main-alt" },
          { group: "Mains", label: "Vegan", value: "Butterbean and paprika enchiladas", tone: "vegan" },
          { group: "Sides", label: "Sides", value: "Mexican rice, roasted broccoli and tortilla chips", tone: "sides" },
          { group: "Dessert", label: "Dessert", value: "Lemon and poppyseed shortbread", tone: "dessert" },
        ],
      },
    ],
  },
  {
    day: "Sunday",
    meals: [
      {
        title: "Breakfast",
        sections: [
          { label: "Porridge", value: "With honey or golden syrup", tone: "breakfast" },
          {
            label: "Cooked breakfast",
            value: "Pork sausages, hash browns, baked beans, scrambled eggs and sauteed mushrooms",
            tone: "cooked",
          },
          {
            label: "Cold breakfast",
            value: "Selection of cereals and yoghurt with a variety of toppings",
            tone: "cold",
          },
        ],
      },
      {
        title: "Dinner",
        sections: [
          {
            group: "Mains",
            label: "Main course 1",
            value: "Barbeque night: sausages, burgers and grilled chicken thigh",
            tone: "bbq",
          },
          {
            group: "Mains",
            label: "Vegan",
            value: "Beetroot and chickpea burger",
            tone: "vegan",
          },
          {
            group: "Sides",
            label: "Sides",
            value: "Pomegranate cous cous, sliced tomato, sliced cheese, selection of mixed salads and condiments",
            tone: "sides",
          },
          { group: "Dessert", label: "Dessert", value: "Chocolate chip cookies", tone: "dessert" },
        ],
      },
    ],
  },
  {
    day: "Monday",
    meals: [
      {
        title: "Breakfast",
        sections: [
          { label: "Porridge", value: "With honey or golden syrup", tone: "breakfast" },
          {
            label: "Cooked breakfast",
            value: "Bacon, hash browns, baked beans, scrambled eggs and grilled tomatoes",
            tone: "cooked",
          },
          {
            label: "Cold breakfast",
            value: "Selection of cereals and yoghurt with a variety of toppings",
            tone: "cold",
          },
        ],
      },
    ],
  },
];

function groupSections(sections = []) {
  return sections.reduce((groups, section) => {
    const groupTitle = section.group ?? "";
    const existingGroup = groups.find((group) => group.title === groupTitle);

    if (existingGroup) {
      existingGroup.sections.push(section);
      return groups;
    }

    return [...groups, { title: groupTitle, sections: [section] }];
  }, []);
}

export default function MenuSchedule() {
  return (
    <section className="jp-menu">
      <div className="jp-menu__inner">
        <div className="jp-menu__header">
          <h2 className="jp-menu__title">Rally Menu</h2>
          <p className="jp-menu__subtitle">
            Meals available across the weekend at Mount Kelly.
          </p>
        </div>

        <div className="jp-menu__grid">
          {menuData.map((day) => (
            <article key={day.day} className="jp-menu__card">
              <h3 className="jp-menu__day">{day.day}</h3>

              <div className="jp-menu__meals">
                {day.meals.map((meal) => (
                  <div key={`${day.day}-${meal.title}`} className="jp-menu__meal">
                    <h4 className="jp-menu__meal-title">{meal.title}</h4>
                    <div className="jp-menu__sections">
                      {groupSections(meal.sections).map((group) => (
                        <div
                          key={`${day.day}-${meal.title}-${group.title || "sections"}`}
                          className={group.title ? "jp-menu__course" : "jp-menu__course jp-menu__course--plain"}
                        >
                          {group.title && <h5 className="jp-menu__course-title">{group.title}</h5>}

                          <div className="jp-menu__course-items">
                            {group.sections.map((section) => (
                              <div
                                key={`${day.day}-${meal.title}-${section.label}`}
                                className={`jp-menu__section jp-menu__section--${section.tone}`}
                              >
                                <div className="jp-menu__section-label">{section.label}</div>
                                <p className="jp-menu__section-value">{section.value}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
        <p className="jp-menu__note">
          Vegetarian options will be available for all meals, and these will also be suitable for vegans.
          If you have additional dietary requirements, please contact us and we’ll do our best to accommodate them.
        </p>
      </div>
    </section>
  );
}
